import { Component, effect, inject, input, output, signal } from '@angular/core'

import { ArticlesService } from '../../../../../api/articles-service/articles.service'
import { FilterStringsSelectAccordion } from '../components/filter-accordion/filter-items-accordion/filter-select-accordion/filter-strings-select-accordion'
import { FilterStringsSelectDialog } from '../components/filter-dialog/filter-items-dialog/filter-select-accordion/filter-strings-select-dialog'
import type { stringMap } from '../components/types'

@Component({
  selector: 'dhp-source-select-filter',
  templateUrl: './source-select-filter.html',
  imports: [FilterStringsSelectDialog, FilterStringsSelectAccordion],
})
export class SourceSelectFilter {
  //region Services
  // Inject the articleService using dependency injection.
  private readonly articlesService = inject(ArticlesService)
  //endregion Services

  //region Inputs
  // The selection and essence magazine to get the sources from
  public selectionAndEssenceId = input<number | null>()
  //endregion Inputs

  //region Outputs
  // the sources to filter on
  protected selectedSources = output<Set<stringMap> | null>()
  //endregion Outputs

  //region Properties
  // The name of the filter.
  protected filterName = 'common.filter.strings.sources'
  // The sources that can be filtered on
  protected readonly sourceItems = signal(new Set<stringMap>())

  //endregion Properties

  constructor() {
    effect(onCleanup => {
      const id = this.selectionAndEssenceId()

      this.sourceItems.set(new Set())
      this.selectedSources.emit(null)

      if (!id) return

      const sub = this.articlesService
        .getSelectionAndEssenceSources(id)
        .subscribe({
          next: sources => {
            this.sourceItems.set(sources)
          },
          error: (_err: unknown) => {
            // On error, reset to a safe, empty state and keep/emit null selection.
            this.sourceItems.set(new Set())
            this.selectedSources.emit(null)
          },
        })

      onCleanup(() => {
        sub.unsubscribe()
      }) // prevents stale subscriptions when id changes
    })
  }
}
